'use client';
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { getTranslations } from '@/lib/i18n';

export default function SiteFooter() {
  const { language } = useLanguage();
  const t = getTranslations(language);

  return (
    <footer className="w-full border-t border-border bg-card mt-12">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 2xl:px-16 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-sm text-muted-foreground text-center sm:text-left">
          {t?.footerRates}{' '}
          <span className="font-semibold text-foreground">
            {t?.footerBNB}
          </span>{' '}
          {t?.footerFixing}{' '}
          <span className="font-semibold text-foreground">01.01.2025</span>.
        </p>
        <p className="text-xs text-muted-foreground">
          {t?.footerCopyright}
        </p>
      </div>
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 2xl:px-16 py-4 border-t border-border flex flex-col items-center gap-1 text-center">
        <p className="text-xs text-muted-foreground">
          <span className="font-medium text-foreground">{t?.footerAuthor}:</span> {t?.footerAuthorName}
        </p>
        <p className="text-xs text-muted-foreground">
          <span className="font-medium text-foreground">{t?.footerSchool}:</span> {t?.footerSchoolName}
        </p>
        <p className="text-xs text-muted-foreground">
          <span className="font-medium text-foreground">{t?.footerTheme}:</span> {t?.footerThemeName}
        </p>
      </div>
    </footer>
  );
}